import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { setupIonicReact } from '@ionic/react';
import { Auth0Provider } from '@auth0/auth0-react';

// Configuração do Ionic
setupIonicReact();

const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const audience = import.meta.env.VITE_AUTH0_AUDIENCE || 'https://trackento.com/api';

if (!domain || !clientId) {
  throw new Error('Missing Auth0 configuration. Define VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID.');
}

// Configuração mais robusta do Auth0
const auth0Config = {
  domain,
  clientId,
  authorizationParams: {
    redirect_uri: `${window.location.origin}/callback`,
    audience,
  },
  useRefreshTokens: true,
  cacheLocation: 'localstorage' as const,
  useRefreshTokensFallback: true,
  sessionCheckExpiryDays: 1,
  onRedirectCallback: (appState: any) => {
    console.log('onRedirectCallback chamado:', appState);
    // Redireciona para a página desejada após login
    window.history.replaceState(
      {},
      document.title,
      appState?.returnTo || window.location.pathname
    );
  },
};

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <Auth0Provider {...auth0Config}>
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

// Habilita funcionalidades de PWA caso necessário
defineCustomElements(window);
